import { memoize, uniqueByKey } from '@ls/js-utils';
import { SummaryType } from '@ls/grouping-service';
import SelectionState from 'state/selections/SelectionState';
import scope from "./scope"
import { createSelector } from 'reselect';
import { selectSideBySideValue } from "state/selections/selector";

export const selectData = (summaryType) => state => state[scope]['data'][summaryType];
export const selectFetchingData = (summaryType) => state => state[scope]['fetchingData'][summaryType];
export const selectFetchingScenarioAnalysisSbsData = (summaryType) => (state) =>
    state[scope]["fetchingScenarioAnalysisSbsData"][summaryType];
export const selectScenarioAnalysisSbsData = (summaryType) => (state) =>
    state[scope]["scenarioAnalysisSbsData"][summaryType];
export const selectSelectedAccountEntityId = (selectionState) => state => state[selectionState].entityIds;
export const selectSelectedBenchmarkEntityId = (selectionState) => state => state[selectionState].benchmarkEntityId;

export const selectDefinitions = memoize((selectionState) => {
    if (selectionState === SelectionState.UNCOMMITTED) {
        return state => state[scope]['definitions'][selectionState];
    }
    return createSelector(
        state => state[scope]['definitions'][selectionState],
        (definitions) => {
            const completeDefinitions = definitions.filter(({ complete }) => complete);
            return completeDefinitions.filter(uniqueByKey(completeDefinitions, 'key'));
        },
    );
});


export const selectRowMap = createSelector(
    selectDefinitions(SelectionState.COMMITTED),
    selectData(SummaryType.ABSOLUTE),
    selectData(SummaryType.RELATIVE),
    selectScenarioAnalysisSbsData(SummaryType.ABSOLUTE),
    selectScenarioAnalysisSbsData(SummaryType.RELATIVE),
    selectSideBySideValue(SelectionState.COMMITTED),
    (definitions, absData, relData, absSbsData, relSbsData, sideBySide) => {
        const absEntitySummaries = absData?.root?.entitySummaries ?? [];
        const relEntitySummaries = relData?.root?.entitySummaries ?? [];
        const absSbsEntitySummaries = absSbsData?.root?.entitySummaries ?? [];
        const relSbsEntitySummaries = relSbsData?.root?.entitySummaries ?? [];
        const entityRowsMap = {};
        const benchmarkEntityIdSet = new Set();
        [...absEntitySummaries, ...relEntitySummaries].forEach((entitySummary) => {
            const benchId = entitySummary?.entityResultMetaData?.benchId ?? null;
            if (benchId) {
                benchmarkEntityIdSet.add(benchId);
            }
        });

        definitions.forEach((definition) => {

            const { key, scenarioType, scenarioAnalysisId } = definition
            const processEntitySummary = (entitySummary, scenario) => {
                const { scenarios, entityResultMetaData } = entitySummary;
                const { entityId } = entityResultMetaData;
                const filteredScenario = scenarios.filter((scenarioSummary) => scenarioSummary["primaryKey"]["scenarioId"] === scenarioAnalysisId)
                const valueType = !!filteredScenario && filteredScenario.length > 0 ? filteredScenario[0][`values${scenarioType}`] : ""
                const colId = `${key}${scenario ? ` - scenario` : ""}`;

                if (!entityRowsMap[entityId]) {
                    entityRowsMap[entityId] = {};
                }
                entityRowsMap[entityId][colId] =
                    valueType[definition.scenarioAnalysisFactor.toLowerCase()];

            };
            (definition.calcType === 'Account'
                ? absEntitySummaries
                : relEntitySummaries
            ).forEach((entitySummary) => {
                processEntitySummary(entitySummary);
            });
            if (sideBySide) {
                (definition.calcType === 'Account'
                    ? absSbsEntitySummaries
                    : relSbsEntitySummaries
                ).forEach((entitySummary) => {
                    processEntitySummary(entitySummary, true);
                });
            }
        });
        return entityRowsMap;


    }
);






